module.exports = __webpack_public_path__ + "img/bo.cc8d0efa.svg";